module.exports = __webpack_public_path__ + "img/bepreisung_marker.e05c7d24.png";